// ============================================================
// API client - Fase 1.
//
// apiFetch: wrapper alrededor de fetch que:
//   - Siempre incluye credentials para que la cookie de sesion viaje
//   - Asume Content-Type JSON (override-able via init.headers)
//   - Lanza un Error tipado si la respuesta no es 2xx
//
// El proxy de Vite (apps/web/vite.config.ts) reenvia /api/* y /healthz
// al backend en :8082, asi que las URLs son relativas.
// ============================================================

export interface ApiError extends Error {
  status: number;
  body?: unknown;
}

function makeApiError(status: number, message: string, body?: unknown): ApiError {
  const err = new Error(message) as ApiError;
  err.name = 'ApiError';
  err.status = status;
  err.body = body;
  return err;
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (!headers.has('Content-Type') && init.body) {
    headers.set('Content-Type', 'application/json');
  }

  const res = await fetch(path, {
    ...init,
    headers,
    credentials: 'include',
  });

  if (res.status === 204) return undefined as T;

  const contentType = res.headers.get('content-type') ?? '';
  const isJson = contentType.includes('application/json');
  const body = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    throw makeApiError(res.status, `API ${res.status} on ${path}`, body);
  }
  return body as T;
}
